var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/solid/cog"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7875 3.80512C13.3326 1.93162 10.6682 1.93162 10.2133 3.80512C9.91951 5.01539 8.53293 5.58973 7.46939 4.9417C5.82301 3.93854 3.93894 5.82261 4.9421 7.46899C5.59012 8.53253 5.01578 9.91912 3.80552 10.2129C1.93201 10.6678 1.93201 13.3322 3.80552 13.7871C5.01578 14.0809 5.59012 15.4675 4.9421 16.531C3.93894 18.1774 5.82301 20.0614 7.46939 19.0583C8.53293 18.4103 9.91951 18.9846 10.2133 20.1949C10.6682 22.0684 13.3326 22.0684 13.7875 20.1949C14.0813 18.9846 15.4679 18.4103 16.5314 19.0583C18.1778 20.0614 20.0618 18.1774 19.0587 16.531C18.4107 15.4675 18.985 14.0809 20.1953 13.7871C22.0688 13.3322 22.0688 10.6678 20.1953 10.2129C18.985 9.91912 18.4107 8.53253 19.0587 7.46899C20.0618 5.82261 18.1778 3.93854 16.5314 4.9417C15.4679 5.58973 14.0813 5.01539 13.7875 3.80512ZM12.0004 15.6C13.9886 15.6 15.6004 13.9882 15.6004 12C15.6004 10.0118 13.9886 8.39999 12.0004 8.39999C10.0122 8.39999 8.40039 10.0118 8.40039 12C8.40039 13.9882 10.0122 15.6 12.0004 15.6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSet);
export default __webpack_public_path__ + "static/media/icon_set.bfd6e127cc4e7336e0b48d0f17ca3767.svg";
export { ForwardRef as ReactComponent };